import React, { useState } from "react";
import { IconCalendar } from "./DemoIcons";

// Format a Date for a <input type="datetime-local"> value (local time, no tz).
const toLocalInput = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

function DemoArchiveControl({ live, isConnected, archiveLabel, onLiveToggle, onArchivePick }) {
  const [pickerOpen, setPickerOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const archiveDays = parseInt(process.env.REACT_APP_ARCHIVE_DAYS, 10) || 30;
  const minDate = new Date(Date.now() - archiveDays * 86400000);

  return (
    <div className="demo-arch">
      {live ? (
        <span className="demo-live-status">
          <span className={"demo-live-dot" + (isConnected ? "" : " reconnecting")} />
          {isConnected ? "Live" : "Reconnecting"}
        </span>
      ) : (
        <>
          <span className="demo-arch-label demo-mono">{archiveLabel}</span>
          <button className="demo-backlive" onClick={onLiveToggle} title="Return to live">
            <span className="demo-live-dot" /> Live
          </button>
        </>
      )}

      <div className="demo-pop-wrap">
        <button className={"demo-icon-btn" + (pickerOpen || !live ? " active" : "")}
          onClick={() => setPickerOpen((o) => !o)} title="Browse archive by date" aria-label="Browse archive by date">
          <IconCalendar />
        </button>
        {pickerOpen && (
          <>
            <div className="demo-pop-scrim" onClick={() => setPickerOpen(false)} />
            <div className="demo-pop demo-picker" onClick={(e) => e.stopPropagation()}>
              <div className="demo-pop-head">Jump to a date &amp; time</div>
              <input className="demo-picker-input demo-mono" type="datetime-local"
                value={toLocalInput(date)} min={toLocalInput(minDate)} max={toLocalInput(new Date())}
                onChange={(e) => { if (e.target.value) setDate(new Date(e.target.value)); }} />
              <button className="demo-btn demo-btn-primary"
                onClick={() => { onArchivePick(date.getTime()); setPickerOpen(false); }}>
                Go to this time
              </button>
              {!live && (
                <button className="demo-btn" onClick={() => { onLiveToggle(); setPickerOpen(false); }}>
                  Back to live
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DemoArchiveControl;
